function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-sort2"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "sort2",
  clipPath: "url(#clip-sort2)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_12004",
  "data-name": "Group 12004",
  transform: "translate(-3002 -8588)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_12002",
  "data-name": "Group 12002",
  transform: "translate(26571.463 15892.32)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_18097",
  "data-name": "Path 18097",
  d: "M-23565.465-7299.026l3.99,4.814,3.992-4.814Z",
  transform: "translate(0.002 0.892)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7880",
  "data-name": "Rectangle 7880",
  width: 16,
  height: 16,
  transform: "translate(3002 8588)",
  fill: "none"
})));

var SvgSortArrowDown = function SvgSortArrowDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSortArrowDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sort-arrow-down.ee884da3.svg";
export { ForwardRef as ReactComponent };